import styled from 'styled-components';

export const MonthStyle = styled.div(props => ({
    display: "flex",
    flexDirection: "column",
    flex: "1",
    marginBottom: "100px",
}));